<script>
  import { range } from 'd3-array';
  import { scaleLinear } from 'd3-scale';
  import { intcomma } from 'journalize';

  export let title;
  export let color;
  export let tickLabel = undefined;

  export let tickSize = 4;

  export let height = 26 + tickSize;

  let marginTop = 0;
  let marginRight = 0;
  let marginBottom = 16 + tickSize;
  let marginLeft = 0;
  let innerWidth = 0;
  $: skipATick = innerWidth < 768;
  $: width = innerWidth < 768 ? 300 : 400;

  $: colors = color.range();
  $: thresholds = color.domain();
  $: thresholdFormat = (d) => intcomma(d);

  $: x = scaleLinear()
    .domain([-1, colors.length - 1 + 1])
    .rangeRound([marginLeft, width - marginRight]);
  $: barWidth = x(1) - x(0);

  $: tickValues = range(thresholds.length);
  $: tickFormat = (i) => thresholdFormat(thresholds[i], i);
</script>

<svelte:window bind:innerWidth />

<p>{title}</p>
<svg
  {width}
  {height}
  viewBox="0,0,{width},{height}"
  style="overflow: visible; display: block;"
>
  <g>
    {#each colors as color, idx}
      <rect
        x={x(idx - 1)}
        y={marginTop}
        width={barWidth}
        height={height - marginTop - marginBottom}
        fill={color}
      />
    {/each}
    <rect
      x={x(colors.length - 1)}
      y={marginTop}
      width={barWidth}
      height={height - marginTop - marginBottom}
      fill="#c6c6c6"
    />
  </g>
  <g class="axis x-axis">
    {#each tickValues as tick, idx}
      <g class="tick tick-{tick}" transform="translate({x(tick)}, {height})">
        <line y1="-{height}" y2="-{marginBottom}" x1="0" x2="0" />
        {#if !skipATick || (idx - 1) % 2}
          <text class="legend-tick" y="-0.5em" text-anchor="middle">
            {tickFormat(tick)}
            {#if idx === 0 && tickLabel}{tickLabel}{/if}
          </text>
        {/if}
      </g>
    {/each}
    <g
      class="tick tick-end"
      transform="translate({x(tickValues.length) + barWidth / 2}, {height})"
    >
      <line y1="-{height}" y2="-{marginBottom}" x1="0" x2="0" />
      <text class="legend-tick" y="-0.5em" text-anchor="middle">No data</text>
    </g>
  </g>
</svg>

<style>
  p {
    font-family: var(--font-sans-serif);
    font-size: 0.8125rem;
    font-weight: 700;
    line-height: 1.2;
    margin: 0 0 0.25rem;
  }
</style>
